import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UtilitiesService } from '../utilities/utilities.service';
import { CartService } from './cart.service';

declare var window: any;
@Injectable({
    providedIn: 'root',
})
export class AppiceService {
    private httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),

    };
    ACCOUNT_IMG_LISTS: any;

    constructor(
        private http: HttpClient,
        private UTS: UtilitiesService,
        private CS: CartService,
    ) { }

    addDataOnBuyNow_Plan(product) {

        try {
            var category = this.getCategory();
            var catName = this.getCategoryName();
            var subCategory = this.getSubCategory();

            sessionStorage.setItem('category', category);
            sessionStorage.setItem('catName', catName);
            sessionStorage.setItem('subCategory', subCategory);

            var object = {};
            object['name'] = "BuyNow";
            object['properties'] = {

                'Category': category,
                'SubCategory': catName,
                'SubCategoryID': subCategory,
                'ProductID': product.productId,
                'skuID': product.skus[0].skuId,
                'DisplayName': product.skus[0].displayName,
                'DisplayNameAr': '',
                'DeepLink': window.location.href,
                'PaymentAmount': product.skus[0].listPrice,
                'PaymentTerm': '',
                'InStock': 'True'

            }
            this.clickEvent(object);
        } catch (e) {
        }
    }
    addDataOnBuyNow_Device(product) {

        try {
            var category = this.getCategory();
            var catName = this.getCategoryName();
            var subCategory = this.getSubCategory();

            sessionStorage.setItem('category', category);
            sessionStorage.setItem('catName', catName);
            sessionStorage.setItem('subCategory', subCategory);

            var object = {};
            object['name'] = "BuyNow";
            object['properties'] = {

                'Category': category,
                'SubCategory': catName,
                'SubCategoryID': subCategory,
                'ProductID': product.productId,
                'skuID': product.skuId,
                'DisplayName': product.productName,
                'DisplayNameAr': '',
                'DeepLink': window.location.href,
                'PaymentAmount': product.price,
                'PaymentTerm': '',
                'InStock': ''

            }
            this.clickEvent(object);
        } catch (e) {
        }
    }

    addDataOnBuyNowContinue(skuID, productName) {

        try {
            var category = this.getCategory();
            sessionStorage.setItem('category', category);

            var object = {};
            object['name'] = "BuyNowContinue";
            object['properties'] = {
                'skuID': skuID,
                'ProductName': productName,
                'ProductID': '',
                'CatName': category,
                'Continue': 'True'

            }
            this.clickEvent(object);
        } catch (e) {
        }
    }

    addDataOnAddToCart_Device(product, selectedSku, deviceQuanity) {

        try {
            var object = {};
            object['name'] = "AddToCart";
            object['properties'] = {

                'ProductID': product.productId,
                'skuID': selectedSku.skuId,
                'CommerceItemId': '',
                'DisplayName': selectedSku.displayName,
                'DisplayNameAr': selectedSku.displayNameAr,
                'DeepLink': window.location.href,
                'InStock': selectedSku.inStock,
                'isPreOrder': product.isPreOrder,
                'TotalPayNow': selectedSku.listPrice,
                'isCODAllowed': '',
                'Quantity': deviceQuanity

            }
            this.clickEvent(object);
        } catch (e) {
        }
    }


    addDataOnAddToCart_Plan(product) {
        try {
            var object = {};
            object['name'] = "AddToCart";
            object['properties'] = {

                'ProductID': product.productId,
                'skuID': product.skuId,
                'CommerceItemId': '',
                'DisplayName': product.displayName,
                'DisplayNameAr': product.displayNameAr,
                'DeepLink': window.location.href,
                'InStock': '',
                'isPreOrder': product.isPreOrder,
                'TotalPayNow': product.listPrice,
                'isCODAllowed': '',
                'Quantity': product.quantity

            }
            this.UTS.log("object" + JSON.stringify(object));
            this.clickEvent(object);
        } catch (e) {
        }
    }

    addDataOnCartCheckout_Device(promoCode: any, deliveryMode: any) {

        try {
            var object = {};
            object['name'] = "CartCheckout";
            object['properties'] = {

                'PromoCode': promoCode > 0 ? 'True' : 'False',
                'DeliveryMode': deliveryMode
            }
            this.UTS.log("object" + JSON.stringify(object));
            this.clickEvent(object);
        } catch (e) {
        }
    }

    addDataOnPayment_Device(paymentMethod: any, failureReason: any, paymentStatus: any) {
        try {
            var object = {};
            object['name'] = "Payment";
            object['properties'] = {

                'PaymentMethod': paymentMethod,
                'FailureReason': failureReason,
                'PaymentStatus': paymentStatus
            }
            this.UTS.log("object" + JSON.stringify(object));
            this.clickEvent(object);
        } catch (e) {
        }
    }

    addDataOnHomeBrowsing() {

        try {
            var category = this.getCategory();
            var catName = this.getCategoryName();
            var subCategory = this.getSubCategory();

            sessionStorage.setItem('category', category);
            sessionStorage.setItem('catName', catName);
            sessionStorage.setItem('subCategory', subCategory);

            var object = {};
            object['name'] = "HomePageBrowsing";
            object['properties'] = {

                'Category': category,
                'SubCategory': catName,
                'SubCategoryID': subCategory
            };
            this.UTS.log("object" + JSON.stringify(object));
            this.clickEvent(object);
        } catch (e) {
        }
    };

    clickEvent(object) {
        try {
            if (window.Appice) {
                window.Appice.recordEvent({
                    key: object.name,
                    segment: object.properties
                });
            }
        } catch (e) {
        }
    }

    formatPrice(price, pricision) {
        try {


            if (price == undefined) {
                return price;
            } else {
                return Number(Math.round(Number(price) * 100) / 100).toFixed(pricision).toString();
            }
        } catch (e) {
        }
    }

    getCategory() {
        var catName = '';//$location.search()['category'];
        // if(catName== undefined ){
        if (localStorage.getItem('category') && localStorage.getItem('category') != "undefined") {
            catName = localStorage.getItem('category');
        }
        // }

        return catName;
    };

    getCategoryName() {
        var catName = '';// $location.search()['catName'] || "";

        if (localStorage.getItem('catName') && localStorage.getItem('catName') != "undefined") {
            catName = localStorage.getItem('catName');
        }
        else if (sessionStorage.getItem('listVal') && sessionStorage.getItem('listVal') != "undefined") {
            catName = sessionStorage.getItem('listVal');
        }


        return catName;
    };

    getSubCategory() {
        var catName = '';// $location.search()['subCategory'];
        // if(catName== undefined ){
        if (localStorage.getItem('subCategory') && localStorage.getItem('subCategory') != "undefined") {
            catName = localStorage.getItem('subCategory');
        }
        // }

        return catName;
    }


    passAllProductsToCart(screenName, eventName, item, userInfo) {
        try {
            const payload = {
                name: (eventName) ? eventName : '',
                properties: {}
            }
            this.objectManagment(screenName, item, userInfo).then(res => {
                payload.properties = res
                this.clickEvent(payload);
            })

        } catch (e) {
        }
    }

    onError(screenName, errorName, error, userInfo) {
        try {
            var object = {};
            object['name'] = errorName;
            object['properties'] = {

                'ScreenName': screenName,
                'user_env': this.UTS.getENV(),
                'UserType': userInfo.userType ? userInfo.userType : 'guest',
                'Error': error

            }
            this.UTS.log(object);
            this.clickEvent(object);
        } catch (e) {
        }
    }

    objectManagment(screenName, item, userInfo) {
        return new Promise((resolve, reject) => {
            let payload = {}
            const catName = this.getCategoryName();
            const subCategory = this.getSubCategory();
            if (item.commerceItemType && item.commerceItemType == "mobilePlanSku") {

                var flexiMin = item.dynamicAttributesList.find(x => x.key == 'Flexi Minutes');
                var localData = item.dynamicAttributesList.find(x => x.key == 'Local Data');
                localData.value = localData.value.split('G')

                this.CS.getProductDetails(item).subscribe((result: any) => {
                    payload = {
                        'ScreenName': (screenName) ? screenName : '',
                        'user_env': (this.UTS.getENV()) ? this.UTS.getENV() : 'web',
                        'UserType': (userInfo && userInfo.userType) ? userInfo.userType : 'guest',
                        'Category': (item && item.commerceItemCategory) ? item.commerceItemCategory : '',
                        'SubCategory': (catName) ? catName : '',
                        'SubCategoryID': (subCategory) ? subCategory : '',
                        'ProductID': (item && item.productId) ? item.productId : '',
                        'skuID': (item && item.skuId) ? item.skuId : '',
                        'DisplayName': (item && item.displayName) ? item.displayName : '',
                        'DisplayNameAr': (item && item.displayNameAr) ? item.displayNameAr : (item && item.parentDisplayNameAr) ? item.parentDisplayNameAr : '',
                        'DeepLink': window.location.href,
                        'PaymentAmount': (item && item.price && item.price.oneTime) ? item.price.oneTime : '',
                        'PaymentTerm': item?.contractDuration,
                        'PassType': result.planSkus[0] && result.planSkus[0]?.allowedPassesWithPlan > 0 ? true : false,
                        'localData': Number(localData.value[0]),
                        'FlexiMinutest': Number(flexiMin.value),
                        'PreferredNumbers': item?.accountNumberSelected,
                    }
                    resolve(payload)
                })
            } else {
                payload = {
                    'ScreenName': (screenName) ? screenName : '',
                    'user_env': (this.UTS.getENV()) ? this.UTS.getENV() : 'web',
                    'UserType': (userInfo && userInfo.userType) ? userInfo.userType : 'guest',
                    'Category': (item && item.commerceItemCategory) ? item.commerceItemCategory : '',
                    'SubCategory': (catName) ? catName : '',
                    'SubCategoryID': (subCategory) ? subCategory : '',
                    'ProductID': (item && item.productId) ? item.productId : '',
                    'skuID': (item && item.skuId) ? item.skuId : '',
                    'DisplayName': (item && item.displayName) ? item.displayName : '',
                    'DisplayNameAr': (item && item.displayNameAr) ? item.displayNameAr : (item && item.parentDisplayNameAr) ? item.parentDisplayNameAr : '',
                    'DeepLink': window.location.href,
                    'PaymentAmount': (item && item.paymentOptions && item.paymentOptions.priceIncVAT) ? item.paymentOptions.priceIncVAT : '',
                    'InStock': true,
                }
                resolve(payload)
            }
        })
    }



}
